import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import {BrowserRouter as Router, Route, Switch, Link} from 'react-router-dom';
import Home from "../Pages/Home";
import About from "../Pages/About";
import Login from "../Pages/Login";
import Register from "../Pages/Register";
import Statistic from "../Pages/Statistic";
import Test from "../Pages/Test";
import ProtectRoute from "../Components/ProtectRoute";
import Github_icon from "../images/github_icon.png";

class navbar extends React.Component {
    // check if user is logged in
    constructor(props) {
        super(props);
        this.state = {
            isLoggedIn: false,
            user: null
        };
    }

    componentDidMount() {
        // check if user is logged in
        if (sessionStorage.getItem('isLoggedIn') === 'true') {
            this.setState({
                isLoggedIn: true,
            });
        }
    }
    
    render() {
        return (
            <Router>
                <div className="mb-4">
                    <Navbar bg="dark" expand="lg" variant="dark">
                    <Container>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="me-auto">
                                <Nav.Item>
                                    <Nav.Link className='h5'  as={Link} to="/">Weather Monitor</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link  as={Link} to="/">Home</Nav.Link>
                                </Nav.Item>
                                 <Nav.Item>
                                    <Nav.Link as={Link} to="/statistic">Statistic</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link as={Link} to="/overtime">OverTime</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link as={Link} to="/about">About</Nav.Link>
                                </Nav.Item>
                            </Nav>
                                {this.state.isLoggedIn ?
                                    <h6> You are logged in </h6>
                                    :
                                    <Nav>
                                        <Nav.Item>
                                            <Nav.Link as={Link} to="/login">Login</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link as={Link} to="/register">Register</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                }
                        </Navbar.Collapse>
                    </Container>

                    </Navbar>
                     <Switch>
                        <ProtectRoute path="/" exact component={() => <Home/>}/>
                        <ProtectRoute path="/about" exact component={() => <About/>}/>
                         <ProtectRoute path="/overtime" exact component={() => <Test/>}/>
                        <ProtectRoute path="/statistic" exact component={() => <Statistic/>}/>
                        <Route path="/register" exact component={() => <Register/>}/>
                        <Route path="/login" exact component={() => <Login/>}/>
                     </Switch>
                </div>
                <footer className="footer mt-auto py-3 text-center">
                    <div className="container">
                        <span className="text-muted">&copy; 2021 Weather Monitor</span>
                        <a href="https://github.com/Jaylapuck/IOT_Final_Project_Front_End" target="_blank" rel="noopener noreferrer">
                            <img src={Github_icon} alt="github_icon" className="img-fluid" style={{width: "30px", height: "30px"}}/>
                        </a>
                    </div>
                </footer>
            </Router>
        );
    }
}

export default navbar;
